<template>
  <v-container class="px-0" dense fluid>
    <v-row dense>
      <v-col>
        <PlotChart class="px-0" ref="chart" :propsValues="measuredValues" :propsYRange="yRange" :propsXRange="xRange" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PlotChart from '@/components/organisms/report/chart/PlotChart'

export default {
  name: 'PlotChartCard',

  components: {
    PlotChart,
  },
  props: {
    measuredValues: {
      type: Array,
      required: true,
    },
    propsXRange: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      characteristic: this.propsCharacteristic,
      yRange: [0, 0],
    }
  },
  computed: {
    xRange: {
      get() {
        return this.propsXRange
      },
    },
  },

  mounted() {
    let min = Number.MAX_SAFE_INTEGER
    let max = Number.MIN_SAFE_INTEGER
    const values = this.measuredValues.map((measuredValue) => measuredValue.value)
    const uppers = this.measuredValues.map((measuredValue) => measuredValue.limit.upper + measuredValue.limit.std)
    const lowers = this.measuredValues.map((measuredValue) => measuredValue.limit.lower + measuredValue.limit.std)
    let saUppers = []
    this.measuredValues.forEach((el) => {
      if (el.saLimit.upper) {
        saUppers.push(el.saLimit.upper + el.saLimit.std)
      }
    })
    let saLowers = []
    this.measuredValues.forEach((el) => {
      if (el.saLimit.lower) {
        saLowers.push(el.saLimit.lower + el.saLimit.std)
      }
    })
    let ucl = []
    this.measuredValues.forEach((el) => {
      if (el.controlLimit.ucl) {
        ucl.push(el.controlLimit.ucl)
      }
    })
    let lcl = []
    this.measuredValues.forEach((el) => {
      if (el.controlLimit.lcl) {
        lcl.push(el.controlLimit.lcl)
      }
    })
    min = Math.min(...values, ...uppers, ...lowers, ...saUppers, ...saLowers, ...ucl, ...lcl)
    max = Math.max(...values, ...uppers, ...lowers, ...saUppers, ...saLowers, ...ucl, ...lcl)
    const margin = (max - min) * 0.01
    this.yRange = [min - margin, max + margin]
  },
}
</script>
